import { IPatient } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { BaseComponentModel } from 'src/app/common/component-model/base-component-model';
import { ComponentModelDependencies } from 'src/app/common/component-model/component-model-dependencies';
import { ComponentModelInfo } from 'src/app/common/component-model/component-model-info';
import { PatientModelName } from 'src/app/shared/models/model-names';

@Injectable({ providedIn: 'root' })
export class PatientComponentModel extends BaseComponentModel<IPatient> {
  /**
   * ComponentModel for all patient relevant actions and dependencies
   */
  constructor(componentModelDependencies: ComponentModelDependencies, componentModelInfo: ComponentModelInfo) {
    super(PatientModelName, componentModelDependencies, componentModelInfo);
  }
}
